import { useCallback } from 'react';

import { useSettings } from '@/data/Settings';
import { getExternalId } from '@/data/utils/externalId';
import { TiktokClientPayload } from '@/pages/api/tracking/tiktok/types';
import { useTikTokClickIdentifiers } from 'presentation/events/hooks/useClickIdentifiers';
import { useTrackingStoreLocation } from 'presentation/events/hooks/useTrackingStoreLocation';
import { triggerTikTokConversionEvent } from 'presentation/events/services/tiktokService';
import { getReferrerForTracking, safeDecodeUrl } from 'presentation/events/utils/ga4Utils';

import { SendMediaEventProps } from './types';

export const useTrackPageViewTikTok = () => {
	const { settings } = useSettings();
	const { userData } = settings;
	const { ttclid, ttp } = useTikTokClickIdentifiers();
	const storeLocation = useTrackingStoreLocation();

	const sendTiktokEvent = useCallback(
		({ eventId, personInfo, storeId }: SendMediaEventProps) => {
			if (userData?.ENABLE_TIKTOK_CALL !== 'true') return;

			const tiktokPayload: TiktokClientPayload = {
				event: 'Pageview',
				event_id: eventId,
				properties: {},
				user: {
					email: personInfo?.email ? [personInfo.email] : undefined,
					first_name: personInfo?.firstName,
					last_name: personInfo?.lastName,
					phone: personInfo?.phone ? [personInfo.phone] : undefined,
					city: storeLocation?.city,
					state: storeLocation?.state,
					country: 'mx',
					external_id: [getExternalId()],
					locale: 'es-MX',
					zip_code: storeLocation?.zipCode,
					ttp,
					ttclid,
				},
				page: {
					url: safeDecodeUrl(location.href),
					referrer: getReferrerForTracking(),
				},
				storeId,
				test_event_code: userData?.TIKTOK_TEST_CODE,
			};

			triggerTikTokConversionEvent(tiktokPayload);
		},
		[ttp, ttclid, storeLocation, userData?.ENABLE_TIKTOK_CALL, userData?.TIKTOK_TEST_CODE]
	);

	return { sendTiktokEvent };
};
